(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-image-gallery-carousel').each(function () {
			const carousel = $(this);
			const layout = carousel.data('layout');
			const sliderEl = $('.swiper', carousel)[0];
			const navParent = $('.js-image-gallery-carousel-nav', carousel).parent();

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 20,
				centeredSlides: true,
				slidesPerView: layout === 'small' ? 1.2 : 'auto',

				breakpoints: {
					768: {
						spaceBetween: 30,
						slidesPerView: layout === 'small' ? 1.5 : 'auto',
					},
					1024: {
						spaceBetween: 40,
						slidesPerView: layout === 'small' ? 2 : 'auto',
					}
				},

				pagination: {
					el: $('.js-carousel-nav-pagination', carousel)[0],
					clickable: true,
					renderBullet: function (index, className) {
						return '<span class="carousel-nav__bullet ' + className + '">' + (index + 1) + '</span>';
					},
				},

				navigation: {
					nextEl: $('.js-carousel-nav-next', carousel)[0],
					prevEl: $('.js-carousel-nav-prev', carousel)[0],
				},

				on: {
					beforeInit: function () {
						let numSlides = $('.js-carousel-slide', carousel).length;

						if (numSlides <= 3) {
							this.params.loop = false;
						} else {
							this.params.loop = true;
							this.params.initialSlide = 0;
						}

						if (numSlides <= 1) {
							navParent.css('display', 'none');
						}
					},
				}
			});
		});
	});
})(jQuery, document, window);
